/**
 * Holds the current chat provider (CHAT_PROVIDER_ADA | CHAT_PROVIDER_INTERCOM) so the openChat facade
 * can delegate without relying on window. Set by the app (publisher) when it
 * decides which widget to show; read by the facade when openChat() is called.
 */
export const CHAT_PROVIDER_ADA = 'ada'
export const CHAT_PROVIDER_INTERCOM = 'intercom'

let currentProvider = CHAT_PROVIDER_ADA

export const getChatProvider = () => currentProvider

export const setChatProvider = (provider) => {
  currentProvider = provider === CHAT_PROVIDER_INTERCOM ? CHAT_PROVIDER_INTERCOM : CHAT_PROVIDER_ADA
}
